var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFolder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zxcv123",
    d: "M8.167.667h-5.5C1.658.667.843 1.492.843 2.5l-.01 11c0 1.008.825 1.833 1.834 1.833h14.666c1.009 0 1.834-.825 1.834-1.833V4.333c0-1.008-.825-1.833-1.834-1.833H10L8.167.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zxcv124",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zxcv123"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1890FF",
    mask: "url(#zxcv124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.833V45.833H0z",
    transform: "translate(-12.917 -14.917)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-folder.359e4fe5.svg";
export { ForwardRef as ReactComponent };